export const getIframeLinks = () => {
    return [
      { id: 1, iframe: "https://www.youtube.com/embed/69sGBRRNlKI?si=0hzHyYWONrXRofqs", title: "YouTube video player", description: "" },
      { id: 2, iframe: "https://www.youtube.com/embed/pOSa5qhwJXk?si=ZjOZ-DWxAb8Pg3SJ", title: "YouTube video player", description: "" },
      { id: 3, iframe: "https://www.youtube.com/embed/BJlzT4-hIGw?si=BZMnkWLHgRvYo5lW", title: "YouTube video player", description: "" },
      { id: 4, iframe: "https://www.youtube.com/embed/gyumrSEkzFg?si=G1H5E50iB_Vg26iN", title: "YouTube video player", description: "" },
      { id: 5, iframe: "https://www.youtube.com/embed/MOaCHSckFEo?si=DWZQxRpBTRRCaC0k", title: "YouTube video player", description: "" },
      { id: 6, iframe: "https://www.youtube.com/embed/v9kMzyOgWl8?si=nx4ZJAcFg-AAa71-", title: "YouTube video player", description: "" },
      { id: 7, iframe: "https://www.youtube.com/embed/7dYvPXV6bAQ?si=LP-CsXjgd_bLc2j8", title: "YouTube video player", description: "" },
      { id: 8, iframe: "https://www.youtube.com/embed/-1620uwO3Ls?si=lCnzEEUbkcyNg8hT", title: "YouTube video player", description: "" },
      { id: 9, iframe: "https://www.youtube.com/embed/NefgtzK5BmQ?si=pGNsnP3IS72DafNt", title: "YouTube video player", description: "" },
    ];
  };
  export const getIframeLinks2 = () => {
    return [
      { id: 7, iframe: "https://www.youtube.com/embed/22InR30cbZc?si=NdYVzwyo8VILTd-6", title: "YouTube video player", description: "PMBJP Kendra Owner Testimony: Mirzapur, Uttar Pradesh" },
      { id: 8, iframe: "https://www.youtube.com/embed/bIbmbv669Ik?si=5QFGLQ6Z2JoNEVcd", title: "YouTube video player", description: "PMBJP Kendra Owner Testimony: Guwahati, Assam" },
      { id: 9, iframe: "https://www.youtube.com/embed/AtGTgKH5tCU?si=wz4vovQUOGSEL-vG", title: "YouTube video player", description: "PMBJP Kendra Owner Testimony: Karnataka" },
      { id: 10, iframe: "https://www.youtube.com/embed/Q2PPl-B0OvQ?si=OnUqiML-bwvzRME5", title: "YouTube video player", description: "PMBJP Kendra Owner Testimony: Hyderabad, Telangana" },
      { id: 11, iframe: "https://www.youtube.com/embed/NclC6giGsCA?si=J7L2IKkSDfN1_Y6f", title: "YouTube video player", description: "PMBJP Kendra Owner Testimony: Banglore" },
      { id: 12, iframe: "https://www.youtube.com/embed/wfLcL68szIA?si=_-5wRSmeTX49ep6x", title: "YouTube video player", description: "PMBJP Kendra Owner Testimony: Jalandhar, Punjab" },
    ];
  };
  
  export const fetchIframeLinks = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getIframeLinks());
      }, 1000); 
    });
  };
  
  export const fetchIframeLinks2 = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getIframeLinks2());
      }, 1000); 
    });
  };
  
